import React, { Fragment, useEffect, useState } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { postMethod } from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";

const Session = (props) => {
  const [grid, setGrid] = React.useState([]);
  const [load, setLoad] = React.useState(false);
  const editRecord = (val) => {
    var temp = window.btoa(val);
    console.log(temp);
    props.history.push("/branch/customer/session/add?id=" + temp);
  };

  const [gridParam, setGridParam] = useState({});
  const columns = [   
    {
      key: "entry_no",
      text: "Entry No.",
      align: "left",
      sortable: true,
    },
    {
      key: "title",
      text: "Title",
      align: "left",
      sortable: true,
    },
    {
      key: "customer_name",
      text: "Customer Name",
      align: "left",
      sortable: true,
    },
    {
      key: "mobile",
      text: "Mobile",
      align: "left",
      sortable: true,
    },  
     {
      key: "no_of_product",
      text: "Products", 
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            {record.no_of_product}
          </Fragment>
        );
      },
    },
    {
      key: "remarks",
      text: "Remarks",
      align: "left",
      sortable: true,
    },  
     {
      key: "date",
      text: "Date",
      align: "left",
      sortable: true,
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <button
              className="btn btn-link btn-sm"
              onClick={() => editRecord(record.tran_id)}
              style={{ marginRight: "5px" }}
            >
              <i className="fa fa-edit"></i>
            </button>
          </Fragment>
        );
      },
    },
  ];

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50],
  };

  useEffect(() => {
    setLoad(true);
    postMethod("api/transactions/customer/session/browse", gridParam).then((data) => {
      setGrid(data.data);
      setLoad(false);
    });
  }, []);

  return (
    <>
      {load ? <Loader /> : null}
      <div className="card card-custom gutter-b">
        <div className="card-header">
          <div className="card-title">
            <h3 className="card-label">Customer Session</h3>
          </div>
          <div className="card-toolbar">
            <a
              href="/branch/customer/session/add"
              className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3"
            >
              <i className="flaticon2-user"></i> Add Session
            </a>
          </div>
        </div>
        <div className="card-body">
          <ReactDatatable config={config} records={grid} columns={columns} />
        </div>
      </div>
    </>
  );
};

export default Session;
